import logger from '@/modules/Logger';
import store from '@/store/index';
import { getDeviceAccessInstance } from '@/utils/getDeviceAccess';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';

export default {
  // set video & audio constraints based on the device availability
  setDeviceAvailability() {
    const meta = buildJoinMeta({ provider: 'agora', lessonId: this.lessonId });

    logger.info(`${joinPrefix('Agora')} Starting device enumeration`, meta);

    return new Promise(async (resolve) => {
      // Safari, Firefox device IDs are only available after the user has granted permission
      await getDeviceAccessInstance.initiateDeviceRequest(this.videoDevice, this.audioDevice);

      navigator.mediaDevices.enumerateDevices().then(async devices => {
        const cameras = devices.filter(device => this.filterDevice('videoinput', device));
        const mics = devices.filter(device => this.filterDevice('audioinput', device));
        const speakers = devices.filter(device => this.filterDevice('audiooutput', device));

        this.constraints.video = this.enableVideo = cameras.length > 0;

        // check if devicedId is present to the list of detected devices
        const selectedCamera = cameras.map(device => device.deviceId).includes(this.videoDevice);
        const selectedMic = mics.map(device => device.deviceId).includes(this.audioDevice);

        // Manual selection of firefox to fix not readable error when active camera becomes unavailable
        let firstCamera = null, firstMic = null;
        if (store.getters['uaParser/isFirefoxBrowser']) {
          firstCamera = cameras[0]?.deviceId;
          firstMic = mics[0]?.deviceId;
        }

        this.videoDevice = this.videoDevice && selectedCamera ? this.videoDevice : firstCamera;
        let audioDeviceAvailable = this.audioDevice && selectedMic;
        this.audioDevice = audioDeviceAvailable ? this.audioDevice : firstMic;

        // select external mic only if the previously selected mic in mobile is not available anymore
        if (store.getters['uaParser/isMobileDevice'] && !audioDeviceAvailable) {
          this.audioDevice = await store.dispatch(`devices/selectExternalMic`);   
        }

        // add audio output in devices list
        this.availableDevices = { cameras, mics, speakers };

        logger.info('Detected media devices', { operation: 'devices:list', payload: this.availableDevices });
        logger.info(`${joinPrefix('Agora')} Device enumeration complete - cameras: ${cameras.length}, microphones: ${mics.length}, speakers: ${speakers.length}`, meta);
        resolve({ cameras: cameras, mics: mics });
      }).catch(error => {
        logger.error(`${joinPrefix('Agora')} Device enumeration failed: ${error.message}`, meta);
        resolve({ cameras: [], mics: [] });
      });
    });
  }
}
